import { StyleSheet } from 'react-native';

import colors, { Theme } from '../../../../theme/Colors';
import Utility from '../../../../utils/Utility';

const ScanFrameStyles = StyleSheet.create({
  alertBoxBehindArea: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },

  alertBoxContainer: {
    position: 'absolute',
    width: 300,
    left: (Utility.getScreenWidth() - 300) / 2,
    backgroundColor: 'white',
    borderRadius: 16,
    justifyContent: 'space-between',
  },
  desktopModal: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  alertMessageContainer: {
    borderBottomColor: colors.borderLight,
    paddingBottom: 16,
    paddingTop: 4,
  },

  alertBoxTitle: {
    fontSize: 18,
    color: colors.foxyBlack,
    width: 300,
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',
  },

  alertBoxTitleLargeMargin: {
    fontSize: 18,
    color: colors.foxyBlack,
    width: 300,
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',
    marginTop: 38,
  },

  alertBoxTitleSmallMargin: {
    fontSize: 18,
    color: colors.foxyBlack,
    width: 300,
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',
    marginTop: 18,
  },

  justifyAlertMessage: {
    fontSize: 14,
    color: colors.silver,
    paddingHorizontal: 20,
    marginTop: 12,
    fontFamily: 'Roboto',
    textAlign: 'justify',
  },

  alertMessage: {
    fontSize: 14,
    color: colors.silver,
    paddingHorizontal: 20,
    marginTop: 12,
    fontFamily: 'Roboto-Regular',
    textAlign: 'center',
  },

  centerAlertMessage: {
    fontSize: 14,
    color: colors.silver,
    paddingHorizontal: 20,
    marginTop: 12,
    fontFamily: 'Roboto-Regular',
    textAlign: 'center',
  },

  leftAlertMessage: {
    fontSize: 14,
    color: colors.silver,
    paddingHorizontal: 20,
    marginTop: 12,
    fontFamily: 'Roboto-Regular',
  },

  actionButtonsContainer: {
    height: 46,
    justifyContent: 'center',
    alignItems: 'center',
  },

  actionButtonText: {
    fontSize: 16,
    width: 256,
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',
    color: colors.foxyBlack,
  },

  hyperLink: {
    fontSize: 14,
    color: colors.green,
    textAlign: 'justify',
    paddingHorizontal: 12,
    marginTop: 12,
  },
  crossStyle: {
    position: 'absolute',
    top: -8,
    right: -8,
    height: 30,
    width: 30,
    borderRadius: 15,
    borderWidth: 2,
    borderColor: 'white',
    backgroundColor: 'black',
    justifyContent: 'center',
    alignItems: 'center',
  },
  alertBoxAnimation: { height: 120, width: 120, alignSelf: 'center' },
});

export default ScanFrameStyles;
